import { openDB } from "idb";
import styles from "../css/SetupTable.module.css";
import { useEffect, useState } from "react";

export default function ItemsTable({
  items,
  occurrencesArray,
  includesArray,
  onItemIncludeToggle,
}) {
  const [categoryNames, setCategoryNames] = useState(null);

  useEffect(
    () =>
      (async () => {
        const db = await openDB(
          "FoodDo",
          +localStorage.getItem("IDBVersion") || 1
        );
        const categoryStore = db
          .transaction("category", "readonly")
          .objectStore("category");

        const updatedCategoryNames = await Promise.all(
          items.map(async (item) => {
            const category = await categoryStore.get(item.category_uuid);
            return category?.category_name;
          })
        );

        setCategoryNames(updatedCategoryNames);
      })(),
    [items]
  );

  return (
    <div
      style={{
        overflowY: "scroll",
        height: "45vh",
      }}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.description} style={{ width: "60%" }}>
              Item
            </th>
            <th style={{ width: "12rem" }}>Category</th>
            <th style={{ width: "4rem" }}>Action</th>
          </tr>
        </thead>

        <tbody>
          {items.map((item, index) => {
            return (
              <tr key={item.item_uuid}>
                <td
                  style={{ display: "flex", justifyContent: "space-between" }}>
                  <span>{item.item_name}</span>
                  <span style={{ color: "blue" }}>
                    {occurrencesArray[index] > 0 &&
                      `[${occurrencesArray[index]} group(s)]`}
                  </span>
                </td>
                <td>
                  {categoryNames ? categoryNames[index] : item.category_uuid}
                </td>
                <td>
                  <button
                    type='button'
                    className={styles.noBgActionButton}
                    style={{
                      backgroundColor: includesArray[index]
                        ?"red" 
                        : "var(--mainColor)",
                      width: "150px",
                      fontSize: "large",
                    }}
                    onClick={(event) => onItemIncludeToggle(index)}>
                    {includesArray[index] ? "Remove" : "Add"}
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
